/**
 * Inline SVG icons for the shell (#92). Static, trusted markup.
 */
import type { ModuleIcon } from './module.types';

const svg = (paths: string): string =>
  `<svg class="shell-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths}</svg>`;

export const MODULE_ICONS: Record<ModuleIcon, string> = {
  home: svg('<path d="M3 10.5 12 3l9 7.5V21h-6v-6H9v6H3z"/>'),
  reader: svg(
    '<path d="M5 3h9l5 5v13H5z"/><path d="M14 3v5h5"/><path d="M8.5 13h7M8.5 16.5h5"/>'
  ),
  files: svg('<path d="M3 6h7l2 2h9v11H3z"/>'),
  todo: svg(
    '<path d="M4 6.5 5.5 8 8 5.5M4 12.5 5.5 14 8 11.5M4 18.5 5.5 20 8 17.5"/><path d="M11 7h9M11 13h9M11 19h9"/>'
  ),
  integrations: svg(
    '<path d="M9 3v5M15 3v5"/><path d="M6 8h12v4a6 6 0 0 1-12 0z"/><path d="M12 18v3"/>'
  ),
  status: svg('<path d="M3 12h4l2.5 6L13 4l2.5 8H21"/>'),
  account: svg(
    '<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>'
  ),
};

export const ARROW_ICON = svg('<path d="M5 12h14M13 6l6 6-6 6"/>');

/** Nav-rail action icons (#92 follow-up chrome cleanup): separate from ModuleIcon. */
export type ActionIcon = 'logout';

export const ACTION_ICONS: Record<ActionIcon, string> = {
  logout: svg(
    '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/>'
  ),
};
